export default "__VITE_ASSET__213bcc5e__"